import $ from 'jquery';

/**
 *
 */
export abstract class UiWidget {
	selector: string;
	elements: JQuery;

	/**
	 *
	 * @param {string} selector
	 */
	constructor(selector){
		this.selector = selector;
		this.elements = $(this.selector);

		this.bindEventListeners();
	}

	bindEventListeners(): void{

	}

}


// WEBPACK FOOTER //
// ./src/js/widgets/abstract.tsx